import { getWithDefault } from "./getWithDefault";

/**
 * @param array the array to be filtered
 * @param key the key to be checked while filtering
 * @param value the value in the supplied key to match
 * @returns
 * the given key equals the provided value
 * @example
 * filterByKeyValue({
 *  array: [{ delete: true }, { delete: false }],
 *  key: "delete",
 *  value: true,
 * }); // [{ delete: true }]
 */
export function filterByKeyValue<T, K extends keyof T, V extends T[K]>({
  array,
  key,
  value,
}: {
  array?: T[];
  key: K;
  value: V;
}) {
  return getWithDefault(
    array?.filter((item) => item[key] === value),
    []
  );
}
